var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSlackWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24.01"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M5.06,15.18a2.52,2.52,0,1,1-2.52-2.52H5.06Zm1.26,0a2.52,2.52,0,0,1,5,0v6.31a2.52,2.52,0,0,1-5,0Z",
  transform: "translate(0 -0.01)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M8.84,5.05a2.52,2.52,0,1,1,2.52-2.52V5.05Zm0,1.29a2.52,2.52,0,0,1,0,5H2.52a2.52,2.52,0,0,1,0-5Z",
  transform: "translate(0 -0.01)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M18.94,8.86a2.52,2.52,0,1,1,2.52,2.52H18.94Zm-1.26,0a2.52,2.52,0,0,1-5,0V2.53a2.52,2.52,0,0,1,5,0Z",
  transform: "translate(0 -0.01)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15.16,19a2.52,2.52,0,1,1-2.52,2.52V19Zm0-1.26a2.53,2.53,0,0,1,0-5.05h6.32a2.53,2.53,0,0,1,0,5.05Z",
  transform: "translate(0 -0.01)"
})));
export { SvgSlackWhite as ReactComponent };
export default __webpack_public_path__ + "static/media/slackWhite.a57cf449.svg";